<script lang="ts">
  import { _ } from 'svelte-i18n';
  import {
    hasEmail,
    hasFacebook,
    hasInstagram,
    hasLinkedin,
    hasPhone,
    hasTwitter,
    hasWebsite
  } from '$lib/stores/selection';

  /**
   * Embedded in a screen that has already named the section.
   *
   * The sidebar shows this as one collapsed section among many and needs its
   * own heading; a guided step devotes a title to it. Only the chrome differs —
   * the checkboxes write to the same stores either way.
   */
  export let embedded = false;

  /**
   * The sidebar's checkbox is 12px because it sits in a 320px column among a
   * dozen other sections. In a step that has the width of the card and one
   * question to ask, the same box reads as an afterthought — and a 12px hit
   * target is a poor one anywhere. Embedded, the control grows to 16px, the
   * label to `text-sm`, and the seven channels spread over three columns
   * instead of two.
   */
  $: box = embedded ? 'h-4 w-4' : 'h-3 w-3';
  $: grid = embedded
    ? 'grid grid-cols-2 gap-x-6 gap-y-3 text-sm text-gray-700 sm:grid-cols-3'
    : 'grid grid-cols-2 gap-1 text-xs text-gray-700';
  $: row = embedded ? 'flex cursor-pointer items-center gap-2.5' : 'flex items-center gap-2';
</script>

<div class={embedded ? '' : 'p-3'}>
  {#if !embedded}
    <div class="mb-2 flex items-center">
      <svg class="filter-mark mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"
        />
      </svg>
      <span class="text-xs font-semibold text-gray-900">{$_('filters.contact.roles')}</span>
    </div>
  {/if}

  <div class={grid}>
    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasWebsite}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.website')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasEmail}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.email')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasPhone}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.phone')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasFacebook}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.facebook')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasLinkedin}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.linkedin')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasInstagram}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.instagram')}</span>
    </label>

    <label class={row}>
      <input
        type="checkbox"
        bind:checked={$hasTwitter}
        class="{box} rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200"
      />
      <span>{$_('data.twitter')}</span>
    </label>
  </div>
</div>
